//TODO: använd plattformens Image komponent!
import React from 'react';
import classNames from 'classnames';
import Image from '../Image';
import ImageZoom from '../ImageZoom';
import { withRouter } from 'react-router';

const ImageBlock = ({
  ImageUrl,
  ImageDescription,
  ImageText,
  UniqueBlockId,
  Modifiers = null,
  ShowCaption = true,
  ShowPhotoCred = false,
  UseZoom,
  Translations = {},
  Sizes = {
    sizes: '(min-width: 1025px) 900px, 100vw',
  },
  ...props
}) => {
  const classes = classNames({
    'c-imageblock': true,
    'c-imageblock--is-sensitive': props.hideSensitiveImage,
    ...Modifiers,
  });

  const btnClasses = classNames({
    'c-imageblock__sensitive__button': true,
    'c-imageblock__sensitive__button--is-loading':
      props.showSensitiveImageIsLoading,
  });

  if (props.location.search.includes('ThrowTestError=true')) {
    throw new Error('This is a test');
  }

  const dataPrintSidebarTitle = props.CurrentPageProps?.Content?.Translations?.imageblock || '';

  return (
    <figure className={classes} data-print-sidebar-title={dataPrintSidebarTitle} data-img-block={'data-img-block'} data-is-member-of-chapter-container={props.isMemberOfChapterContainer || 'false'} data-is-member-of-chapter={props.isMemberOfChapter|| 'false'}>
      {props.hideSensitiveImage && (
        <div className="c-imageblock__sensitive">
          <div className="c-imageblock__sensitive__content">
            <span className="c-imageblock__sensitive__heading">
              {Translations.sensetiveheading}
            </span>
            <span className="c-imageblock__sensitive__text">
              {ImageDescription}
            </span>
            <button
              onClick={props.handleShowSensitiveImages}
              className={btnClasses}
              type="button"
            >
              {props.showSensitiveImageIsLoading &&
                props.SensitiveImageLoadingIcon}
              <span>
                {
                  props.CurrentPageProps.Content.Translations
                    .showsensetiveimages
                }
              </span>
            </button>
          </div>
        </div>
      )}

      {!props.hideSensitiveImage && (
        <ImageZoom
          ImageUrl={ImageUrl}
          Description={ImageDescription}
          ImageText={ImageText}
          UniqueBlockId={'z-' + UniqueBlockId}
          UseZoom={UseZoom}
          Sizes={{
            sizes: '(min-width: 1025px) 900px, 100vw',
          }}
          {...props}
        >
          <Image
            className="c-imageblock__image"
            ImageUrl={ImageUrl}
            Alt={ImageDescription}
            Sizes={Sizes}
            {...props}
          />
        </ImageZoom>
      )}
      {ShowCaption &&
        (ImageText ||
          (ShowPhotoCred && (props.Photographer || props.Illustrator))) && (
          <figcaption className="c-imageblock__text">
            {ImageText}
            {ShowPhotoCred && (
              <div className="c-imageblock__text__photo-cred">
                {props.Photographer && (
                  <div className="c-imageblock__text__photo-cred_text">
                    {Translations.photographer + props.Photographer}
                  </div>
                )}
                {props.Illustrator && (
                  <div className="c-imageblock__text__photo-cred_text">
                    {Translations.illustrator + props.Illustrator}
                  </div>
                )}
              </div>
            )}
          </figcaption>
        )}
    </figure>
  );
};

export default withRouter(ImageBlock);
